import React from 'react';
import Dropzone, { DropEvent } from "react-dropzone";
import './FileUpload.scss';
import { Button } from 'react-bootstrap';


type FilePickerProps = {
    onFilePicked: (files: File[], event: DropEvent) => void;
    maxFiles?: number;
    maxFileSize?: number;
    acceptTypes?: string;
};

const FilePicker = (props: FilePickerProps) => {
    const SIZE_10_MB: number = 10_000_000;
    return (
        <Dropzone
            onDropAccepted={props.onFilePicked}
            accept={props.acceptTypes}
            maxFiles={props.maxFiles}
            maxSize={props.maxFileSize ?? SIZE_10_MB}
            noDrag
        >
            {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <Button className="text-decoration-none d-flex align-items-center" variant="link">
                        <i className="material-icons">add_circle_outline</i> Browse files
                    </Button>
                </div>
            )}
        </Dropzone>
    );
};

export default FilePicker;
